import { render, staticRenderFns } from "./optionSet.vue?vue&type=template&id=cb2ea7c0&"
import script from "./optionSet.vue?vue&type=script&lang=js&"
export * from "./optionSet.vue?vue&type=script&lang=js&"
import style0 from "./optionSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports